"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SUPPORTED_ANNOTATIONS = exports.DEFAULT_SUPPORTED_DECORATORS = exports.DEFAULT_SUPPORTED_STYLES = exports.ELEMENT_MAP = exports.HTML_LIST_ITEM_TAGS = exports.HTML_DECORATOR_TAGS = exports.HTML_MISC_TAGS = exports.HTML_HEADER_TAGS = exports.HTML_LIST_CONTAINER_TAGS = exports.HTML_SPAN_TAGS = exports.HTML_BLOCK_TAGS = exports.DEFAULT_SPAN = exports.DEFAULT_BLOCK = exports.SLATE_DEFAULT_BLOCK = exports.BLOCK_DEFAULT_STYLE = void 0;

var _uniq2 = _interopRequireDefault(require("lodash/uniq"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BLOCK_DEFAULT_STYLE = 'normal'; // Slate block

exports.BLOCK_DEFAULT_STYLE = BLOCK_DEFAULT_STYLE;
var SLATE_DEFAULT_BLOCK = Object.freeze({
  object: 'block',
  type: 'contentBlock',
  data: {
    style: BLOCK_DEFAULT_STYLE
  }
});
exports.SLATE_DEFAULT_BLOCK = SLATE_DEFAULT_BLOCK;
var DEFAULT_BLOCK = Object.freeze({
  _type: 'block',
  markDefs: [],
  style: BLOCK_DEFAULT_STYLE
});
exports.DEFAULT_BLOCK = DEFAULT_BLOCK;
var DEFAULT_SPAN = Object.freeze({
  _type: 'span',
  marks: []
});
exports.DEFAULT_SPAN = DEFAULT_SPAN;
var HTML_BLOCK_TAGS = {
  p: DEFAULT_BLOCK,
  blockquote: _objectSpread({}, DEFAULT_BLOCK, {
    style: 'blockquote'
  })
};
exports.HTML_BLOCK_TAGS = HTML_BLOCK_TAGS;
var HTML_SPAN_TAGS = {
  span: {
    object: 'text'
  }
};
exports.HTML_SPAN_TAGS = HTML_SPAN_TAGS;
var HTML_LIST_CONTAINER_TAGS = {
  ol: {
    object: null
  },
  ul: {
    object: null
  }
};
exports.HTML_LIST_CONTAINER_TAGS = HTML_LIST_CONTAINER_TAGS;
var HTML_HEADER_TAGS = {
  h1: _objectSpread({}, DEFAULT_BLOCK, {
    style: 'h1'
  }),
  h2: _objectSpread({}, DEFAULT_BLOCK, {
    style: 'h2'
  }),
  h3: _objectSpread({}, DEFAULT_BLOCK, {
    style: 'h3'
  }),
  h4: _objectSpread({}, DEFAULT_BLOCK, {
    style: 'h4'
  }),
  h5: _objectSpread({}, DEFAULT_BLOCK, {
    style: 'h5'
  }),
  h6: _objectSpread({}, DEFAULT_BLOCK, {
    style: 'h6'
  })
};
exports.HTML_HEADER_TAGS = HTML_HEADER_TAGS;
var HTML_MISC_TAGS = {
  br: _objectSpread({}, DEFAULT_BLOCK, {
    style: BLOCK_DEFAULT_STYLE
  })
};
exports.HTML_MISC_TAGS = HTML_MISC_TAGS;
var HTML_DECORATOR_TAGS = {
  b: 'strong',
  strong: 'strong',
  i: 'em',
  em: 'em',
  u: 'underline',
  s: 'strike-through',
  strike: 'strike-through',
  del: 'strike-through',
  code: 'code'
};
exports.HTML_DECORATOR_TAGS = HTML_DECORATOR_TAGS;
var HTML_LIST_ITEM_TAGS = {
  li: _objectSpread({}, DEFAULT_BLOCK, {
    style: BLOCK_DEFAULT_STYLE,
    level: 1,
    listItem: 'bullet'
  })
};
exports.HTML_LIST_ITEM_TAGS = HTML_LIST_ITEM_TAGS;

var ELEMENT_MAP = _objectSpread({}, HTML_BLOCK_TAGS, {}, HTML_SPAN_TAGS, {}, HTML_LIST_CONTAINER_TAGS, {}, HTML_LIST_ITEM_TAGS, {}, HTML_HEADER_TAGS, {}, HTML_MISC_TAGS);

exports.ELEMENT_MAP = ELEMENT_MAP;
var DEFAULT_SUPPORTED_STYLES = (0, _uniq2.default)(Object.keys(ELEMENT_MAP).filter(tag => ELEMENT_MAP[tag].style).map(tag => ELEMENT_MAP[tag].style));
exports.DEFAULT_SUPPORTED_STYLES = DEFAULT_SUPPORTED_STYLES;
var DEFAULT_SUPPORTED_DECORATORS = (0, _uniq2.default)(Object.keys(HTML_DECORATOR_TAGS).map(tag => HTML_DECORATOR_TAGS[tag]));
exports.DEFAULT_SUPPORTED_DECORATORS = DEFAULT_SUPPORTED_DECORATORS;
var DEFAULT_SUPPORTED_ANNOTATIONS = ['link'];
exports.DEFAULT_SUPPORTED_ANNOTATIONS = DEFAULT_SUPPORTED_ANNOTATIONS;